module.exports = __webpack_public_path__ + "static/media/red-b.1dc71858.svg";